import React from 'react'

import Image from 'next/image'

import { Column, Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { HOW_IT_WORKS_SECTION_ROADMAP_ITEMS } from './constants'
import { Card, Container, Line, NumberBadge } from './styles'

function HowItWorksSectionRoadmap() {
  const { isTablet, isDesktop, isWideDesktop } = useResponsiveLayout()

  const withImages = isTablet || isDesktop || isWideDesktop

  return (
    <Container>
      {HOW_IT_WORKS_SECTION_ROADMAP_ITEMS.map((item, index) => (
        <Card
          flexDirection={withImages && index % 2 !== 0 ? 'row-reverse' : 'row'}
          key={item.id}
        >
          {withImages && (
            <Row
              justifyContent={index % 2 === 0 ? 'flex-end' : 'flex-start'}
              mb={
                index + 1 === HOW_IT_WORKS_SECTION_ROADMAP_ITEMS.length ? 0 : 8
              }
              width={1 / 2}
            >
              <Image
                alt={item.imageAlt}
                height={120}
                src={item.image.src}
                width={260}
              />
            </Row>
          )}

          <Column
            alignCenter
            flexGrow={withImages ? 1 : 0}
            relative
            width="50px"
          >
            <NumberBadge top={[0, 0, 0, 0, '16px']}>
              <Text accent medium screen24>
                {index + 1}
              </Text>
            </NumberBadge>

            {index < HOW_IT_WORKS_SECTION_ROADMAP_ITEMS.length - 1 && <Line />}
          </Column>

          <Column
            alignItems={
              withImages && index % 2 !== 0 ? 'flex-end' : 'flex-start'
            }
            gap={3}
            pb={[7, 7, 7, 7, 8]}
            width={withImages ? 1 / 2 : 'unset'}
          >
            <Text bold screen20>
              {item.title}
            </Text>

            <Text
              maxWidth="460px"
              regular
              right={withImages && index % 2 !== 0}
              screen20
            >
              {item.caption}
            </Text>
          </Column>
        </Card>
      ))}
    </Container>
  )
}

export default HowItWorksSectionRoadmap
